import { render, staticRenderFns } from "./Arena.vue?vue&type=template&id=638c0f58&scoped=true&"
import script from "./Arena.vue?vue&type=script&lang=js&"
export * from "./Arena.vue?vue&type=script&lang=js&"
import style0 from "./Arena.vue?vue&type=style&index=0&id=638c0f58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638c0f58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
